// import { useEffect, useState } from "react";

// import { BREAKPOINTS } from "../constants/breakpoints";

// export const useBreakpoint = () => {
//   const [isSmallMobile, setIsSmallMobile] = useState(
//     window.innerWidth < BREAKPOINTS.smallMobile
//   );
//   const [isMobile, setIsMobile] = useState(
//     window.innerWidth < BREAKPOINTS.mobile
//   );

//   const [isNavigationMobile, setIsNavigationMobile] = useState(
//     window.innerWidth < BREAKPOINTS.navigation
//   );

//   useEffect(() => {
//     const smallMobileMedia = window.matchMedia(
//       `(max-width: ${BREAKPOINTS.smallMobile - 1}px)`
//     );
//     const mobileMedia = window.matchMedia(
//       `(max-width: ${BREAKPOINTS.mobile - 1}px)`
//     );

//     const navigationMedia = window.matchMedia(
//       `(max-width: ${BREAKPOINTS.navigation - 1}px)`
//     );

//     const handleMobile = (e) => {
//       setIsMobile(e.matches);
//     };

//     const handleNavigation = (e) => {
//       setIsNavigationMobile(e.matches);
//     };

//     handleMobile(mobileMedia);
//     handleNavigation(navigationMedia);

//     mobileMedia.addEventListener("change", handleMobile);
//     navigationMedia.addEventListener("change", handleNavigation);

//     return () => {
//       mobileMedia.removeEventListener("change", handleMobile);
//       navigationMedia.removeEventListener("change", handleNavigation);
//     };
//   }, []);

//   return {
//     isMobile,
//     isDesktop: !isMobile,
//     isNavigationMobile,
//     breakpoint: isMobile ? "mobile" : "desktop",
//   };
// };
import { useEffect, useState } from "react";

import { BREAKPOINTS } from "../constants/breakpoints";

export const useBreakpoint = () => {
  const [isSmallMobile, setIsSmallMobile] = useState(
    window.innerWidth < BREAKPOINTS.smallMobile
  );

  const [isMobile, setIsMobile] = useState(
    window.innerWidth < BREAKPOINTS.mobile
  );

  const [isNavigationMobile, setIsNavigationMobile] = useState(
    window.innerWidth < BREAKPOINTS.navigation
  );

  useEffect(() => {
    const smallMobileMedia = window.matchMedia(
      `(max-width: ${BREAKPOINTS.smallMobile - 1}px)`
    );

    const mobileMedia = window.matchMedia(
      `(max-width: ${BREAKPOINTS.mobile - 1}px)`
    );

    const navigationMedia = window.matchMedia(
      `(max-width: ${BREAKPOINTS.navigation - 1}px)`
    );

    const handleSmallMobile = (event) => {
      setIsSmallMobile(event.matches);
    };

    const handleMobile = (event) => {
      setIsMobile(event.matches);
    };

    const handleNavigation = (event) => {
      setIsNavigationMobile(event.matches);
    };

    handleSmallMobile(smallMobileMedia);
    handleMobile(mobileMedia);
    handleNavigation(navigationMedia);

    smallMobileMedia.addEventListener("change", handleSmallMobile);
    mobileMedia.addEventListener("change", handleMobile);
    navigationMedia.addEventListener("change", handleNavigation);

    return () => {
      smallMobileMedia.removeEventListener(
        "change",
        handleSmallMobile
      );
      mobileMedia.removeEventListener("change", handleMobile);
      navigationMedia.removeEventListener(
        "change",
        handleNavigation
      );
    };
  }, []);

  return {
    isSmallMobile,
    isMobile,
    isDesktop: !isMobile,
    isNavigationMobile,
    breakpoint: isMobile ? "mobile" : "desktop",
  };
};